<template>
  <div>
    <h3
      id="table_5"
      class="mt-3"
    >
      Laadpunten per Regio
    </h3>
    <TableManager
      ref="TableManager"
      class="RVBChargingpointCount"
      :loading="loading"
      :source-records="records"
      category="rvb-customer-reporting"
      uuid="81daa378-e75a-4a5a-b224-4c48849a8bef"
    />
  </div>
</template>

<script>

import TableManager from '@/components/Table/TableManager'
import { mapGetters } from 'vuex'

export default {
  name: '',
  components: {
    TableManager,
  },

  computed: {
    ...mapGetters('realisation', [
      'records',
      'loading',
    ]),
  },

}
</script>

<style lang="scss">
.RVBChargingpointCount {
  // .Table__row {
  //   div:first-child {
  //     font-weight: bold;
  //   }
  // }
  .Table__row:last-child {
    font-weight: bold;
  }
}
</style>
